import { SearchGray300Icon, SearchPrimaryIcon } from '@assets/iconComponents';
import { Box, Button } from '@mui/material';
import { colorSet, typography } from '@theme';
import { Text } from '..';
import { memo, useCallback, useEffect, useRef } from 'react';

interface IContiTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  isbuttondisabled: boolean;
  onButtonClick: () => void;
  boxstyle?: React.CSSProperties;
  style?: React.CSSProperties;
}

export const ContiTextarea = memo((props: IContiTextareaProps) => {
  const { isbuttondisabled, onButtonClick, boxstyle, style, ...textareaProps } = props;

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const adjustHeight = useCallback(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      adjustHeight();
      if (textareaProps.onChange) {
        textareaProps.onChange(e);
      }
    },
    [textareaProps.onChange, adjustHeight]
  );

  useEffect(() => {
    adjustHeight();
  }, [adjustHeight]);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '220px',
        padding: '12px 16px',
        resize: 'none',
        borderRadius: '5px',
        border: `1px solid ${colorSet.gray300}`,
        '&:hover': {
          border: `1px solid ${colorSet.primaryMain}`
        },
        '&:focus-within': {
          border: `1px solid ${colorSet.gray600}`,
          boxShadow: 'none',
          outline: 'none'
        },
        ...boxstyle
      }}
    >
      <textarea
        ref={textareaRef}
        {...textareaProps}
        className="conti-textarea"
        placeholder={'글콘티를 분석하여 검색합니다.'}
        onChange={handleChange}
        style={{
          ...typography.body1,
          width: '100%',
          minHeight: '140px',
          padding: 0,
          outline: 'none',
          resize: 'none',
          border: 'none',
          overflow: 'hidden',
          ...style
        }}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          disabled={isbuttondisabled}
          onClick={onButtonClick}
          sx={{
            width: '90px',
            height: '40px',
            borderRadius: '22px',
            border: `1px solid ${isbuttondisabled ? colorSet.gray300 : colorSet.primaryMain}`
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 4
            }}
          >
            {isbuttondisabled ? <SearchGray300Icon /> : <SearchPrimaryIcon />}
            <Text variant="body2" fontWeight="bold" color={isbuttondisabled ? colorSet.gray300 : colorSet.primaryMain}>
              검색
            </Text>
          </div>
        </Button>
      </div>
    </Box>
  );
});

ContiTextarea.displayName = 'ContiTextarea';
